import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { c as classNames } from "../../index-CweZ_OcN.js";
import "../Icon/index.es.js";
import { IconMenu } from "../icons/IconMenu/index.es.js";
import { Conditional } from "../Conditional/index.es.js";
import { Text } from "../Text/index.es.js";
import { IconChevronDown } from "../icons/IconChevronDown/index.es.js";
import { IconChevronLeft } from "../icons/IconChevronLeft/index.es.js";
import { g as getInitialLetters } from "../../getInitialLetters-CV7onXcH.js";
import { IconBell } from "../icons/IconBell/index.es.js";
import './styles.css';const HeaderActions = ({ children, divider }) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames("au-header__actions", {
        "au-header__actions--divider": divider
      }),
      children
    }
  );
};
const HeaderBadges = ({ children }) => {
  return /* @__PURE__ */ jsx("div", { className: "au-header__badges", children });
};
const HeaderButton = ({ children, onClick }) => {
  return /* @__PURE__ */ jsx("div", { className: "au-header__button", onClick, children });
};
const HeaderHamburger = ({ onClick }) => {
  return /* @__PURE__ */ jsx("div", { className: "au-header__hamburger", children: /* @__PURE__ */ jsx("div", { className: "au-header__hamburger", onClick, children: /* @__PURE__ */ jsx(IconMenu, {}) }) });
};
const HeaderLogo = ({
  children,
  renderMobile,
  renderDesktop
}) => {
  return /* @__PURE__ */ jsxs("div", { className: "au-header__logo", children: [
    /* @__PURE__ */ jsx(
      Conditional,
      {
        condition: !!renderMobile,
        renderIf: /* @__PURE__ */ jsx("div", { className: "au-header__logo--mobile", children: renderMobile })
      }
    ),
    /* @__PURE__ */ jsx(
      Conditional,
      {
        condition: !!renderDesktop,
        renderIf: /* @__PURE__ */ jsx("div", { className: "au-header__logo--desktop", children: renderDesktop })
      }
    ),
    children
  ] });
};
const HeaderNavbar = ({ data, renderItem }) => {
  return /* @__PURE__ */ jsx("nav", { role: "navigation", className: "au-header__navbar", children: data == null ? void 0 : data.map((item) => {
    return renderItem(item);
  }) });
};
const HeaderNavbarLink = (navItem) => {
  const { name, dropdown, active, href } = navItem;
  const isDropdown = !!dropdown && dropdown.length;
  function handleItemClick(item, ev) {
    if (item.onClick) {
      ev.preventDefault();
      item.onClick();
    }
  }
  return /* @__PURE__ */ jsxs(
    Text,
    {
      as: isDropdown ? "div" : "a",
      variant: "heading-micro",
      weight: "light",
      href,
      onClick: (ev) => handleItemClick(navItem, ev),
      title: name,
      className: classNames("au-header__navbar-link", {
        "au-header__navbar-link--is-dropdown": dropdown,
        "au-header__navbar-link--is-active": active
      }),
      children: [
        name,
        /* @__PURE__ */ jsx(
          Conditional,
          {
            condition: !!(dropdown == null ? void 0 : dropdown.length),
            renderIf: /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(IconChevronDown, {}),
              /* @__PURE__ */ jsx("div", { className: "au-header__dropdown", children: dropdown == null ? void 0 : dropdown.map((item) => {
                return /* @__PURE__ */ jsxs(
                  Text,
                  {
                    as: "a",
                    variant: "heading-micro",
                    href: item.href,
                    onClick: (ev) => handleItemClick(item, ev),
                    weight: "light",
                    className: classNames("au-header__dropdown-link", {
                      "au-header__dropdown-link--is-active": item.active
                    }),
                    title: item.name,
                    children: [
                      item.name,
                      /* @__PURE__ */ jsx(
                        Conditional,
                        {
                          condition: !!item.active,
                          renderIf: /* @__PURE__ */ jsx(IconChevronLeft, {})
                        }
                      )
                    ]
                  },
                  item.name
                );
              }) })
            ] })
          }
        )
      ]
    }
  );
};
const HeaderNavigation = ({ children }) => {
  return /* @__PURE__ */ jsx("div", { className: "au-header__navigation", children });
};
const HeaderProfile = ({
  onClickNotifications,
  onClickMenu,
  fullName
}) => {
  const initialLetters = getInitialLetters(fullName);
  return /* @__PURE__ */ jsxs("div", { className: "au-header__profile", children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        className: "au-header__profile-notifications",
        onClick: onClickNotifications,
        children: /* @__PURE__ */ jsx(IconBell, {})
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "au-header__profile-menu-mobile", onClick: onClickMenu, children: /* @__PURE__ */ jsx(IconMenu, {}) }),
    /* @__PURE__ */ jsxs("div", { className: "au-header__profile-menu", onClick: onClickMenu, children: [
      /* @__PURE__ */ jsx("div", { className: "au-header__profile-letters", children: initialLetters }),
      /* @__PURE__ */ jsx(IconChevronDown, {})
    ] })
  ] });
};
const HeaderWrap = ({
  children,
  position = "static"
}) => {
  return /* @__PURE__ */ jsx(
    "header",
    {
      role: "banner",
      className: classNames("au-header", {
        "au-header--fixed": position === "fixed",
        "au-header--static": position === "static"
      }),
      children: /* @__PURE__ */ jsx("div", { className: "au-header__container", children })
    }
  );
};
const components = {
  Actions: HeaderActions,
  Badges: HeaderBadges,
  Button: HeaderButton,
  Hamburger: HeaderHamburger,
  Logo: HeaderLogo,
  Navbar: HeaderNavbar,
  NavbarLink: HeaderNavbarLink,
  Navigation: HeaderNavigation,
  Profile: HeaderProfile,
  Root: HeaderWrap
};
Object.keys(components).forEach((key) => {
  const component = components[key];
  component.displayName = `Header.${key}`;
});
export {
  components as Header
};
//# sourceMappingURL=index.es.js.map
